export default "__VITE_ASSET__BcMl1epu__";